<template>
    <div class="row">
        <b-overlay :show="loading" class="transaction-split">
            <div class="mb-3 text-center">
                <strong>{{ $t("view.club.menus.transactionSplits") }}</strong>
            </div>
            <table class="table table-striped bg-white text-center">
                <thead>
                    <tr>
                        <th>{{ $t("param.record") }}</th>
                        <th v-for="field in fields" v-if="field.showCell" :key="field.key">
                            {{ $t("param." + field.key) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" @click="onShowDatails(item)">
                        <td>
                            {{ index + (currentPage - 1) * perPage + 1 }}
                        </td>
                        <td v-for="field in fields" v-if="field.showCell">
                            {{
                field.money
                  ? new Intl.NumberFormat().format(item[field.key].toFixed(0))
                  : item[field.key]
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <b-pagination dir="ltr"
                          pills
                          @input="initTable"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          size="sm"></b-pagination>
        </b-overlay>
    </div>
</template>
<script>
    export default {
        props: {
            transactionId: 0
        },

        data()
        {
            return {
                loading: false,
                showDetails: false,
                selected: {},
                items: [],
                fields: [
                    {
                        key: "splitYear",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "splitMonthName",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "totalSplitValue",
                        showCell: true,
                        shotDetails: true,
                        money: true
                    }
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 5
            };
        },

        beforeMount()
        {
            this.initTable();
        },

        mounted()
        {
            this.totalRows = this.items.length;
        },

        methods: {
            initTable()
            {
                this.loading = true;
                const data = {
                    Search: "",
                    Start: (this.currentPage - 1) * this.perPage,
                    Length: this.perPage,
                    TransactionID: this.transactionId
                };

                axios({ method: "post", url: "/api/App/GetTransactionSplit", data: data })
                    .then(response =>
                    {
                        this.items = response.data.meta.transactionSplits;
                        this.totalRows = response.data.meta.totalRows;
                        this.loading = false;
                    })
                    .catch(error => { });
            },

            onShowDatails(item)
            {
                this.selected = item;
                this.showDetails = true;
            }
        }
    };
</script>
<style scoped>
    .transaction-split {
        width: 100%;
        min-height: 200px;
    }
</style>
